import _ from 'lodash'
import qs from 'qs'
export default {
  props: {
    tableHeight: Number,
    user: Object
  },
  data () {
    return {
      currentPage: 1,
      minPageSize: Math.floor((this.tableHeight - 70)/32),
      pageSize: Math.floor((this.tableHeight - 70)/32),
      params: {},
      fixedParams: {},
      list: [],
      selectRows: [],
      total: 0,
      exporting: false,
      loading: false
    }
  },
  mounted () {
    if (!this.searchParams) {
      this.fetchList()
    } else {
      this.search(this.searchParams)
    }
  },
  methods: {
    fetchList () {
      if (this.pageSize > 0) {
        this.params.start = (this.currentPage - 1) * this.pageSize
        this.params.limit = this.pageSize
      }
      this.loading = true
      this.$http.get('/dbapi/' + this.sqlcode, {
        params: {
          ...this.params,
          ...this.fixedParams
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(response => {
        this.loading = false
        if (response.data.success) {
          this.list = response.data.list
          this.total = response.data.total
          if (this.selectRow && this.selectRow.id) {
            let srs = this.list.filter(r => r.id === this.selectRow.id)
            if (srs.length === 1) {
              this.selectRow = srs[0]
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    handleSelectionChange (val) {
      this.selectRows = val
    },
    search (params) { // 搜索
      for (let p in params) {
        if (!params[p]) {
          delete params[p]
        }
      }
      this.params = params
      this.currentPage = 1
      this.fetchList()
    },
    inputSearch: _.debounce(function (params) {
      this.search(params)
    }, 500), // 输入中止500毫秒后触发搜索,防止密集输入
    pageChange (val) {
      this.currentPage = val
      this.fetchList()
    },
    pageSizeChange (val) {
      this.pageSize = val
      this.fetchList()
    },
    excel () {
      if (!this.exporting && this.sqlcode) {
        this.exporting = true
        this.$http.get('/dbapi/excel/' + this.sqlcode, {
          params: {
            ...this.params,
            ...this.fixedParams
          },
          paramsSerializer: function(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        }).then(response => {
          this.exporting = false
          if (response.data.success) {
            this.$alert('导出成功,点击下载文件', '导出成功', {
              confirmButtonText: '下载文件',
              callback: action => {
                window.open(response.data.url)
              }
            })
          } else {
            this.$message({ type: 'error', message: '导出失败,' + response.data.message })
          }
        })
      }
    },
    print () {
      window.print()
    },
    refresh () {
      this.fetchList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ListFunc.js